import { defineMessages } from "react-intl";

export const scope = "components.BymaActivitiesScroll";

export const messages = defineMessages({
  detailLabel: {
    id: `${scope}.detailLabel`,
    defaultMessage: "Detalle",
  },
  liquidationDateLabel: {
    id: `${scope}.liquidationDateLabel`,
    defaultMessage: "Fecha de liquidación",
  },
  agreementDateLabel: {
    id: `${scope}.agreementDateLabel`,
    defaultMessage: "Fecha de concertación",
  },
  amountLabel: {
    id: `${scope}.amountLabel`,
    defaultMessage: "Cantidad",
  },
  priceLabel: {
    id: `${scope}.priceLabel`,
    defaultMessage: "Precio",
  },
  netValueLabel: {
    id: `${scope}.netValueLabel`,
    defaultMessage: "Importe",
  },
  receiptPill: {
    id: `${scope}.receiptPill`,
    defaultMessage: "Movimientos entre cuentas",
  },
  couponPill: {
    id: `${scope}.couponPill`,
    defaultMessage: "Compras y ventas",
  },
  checkingAccountPill: {
    id: `${scope}.checkingAccountPill`,
    defaultMessage: "Cuenta corriente",
  },
  showMoreButton: {
    id: `${scope}.showMoreButton`,
    defaultMessage: "Ver más",
  },
});
